var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"#047527"}},[(_vm.taxpercent>0)?_c('span',[_vm._v(_vm._s(_vm.taxpercent)+"% - ")]):_vm._e(),(_vm.calculatedtax>0)?_c('strong',[_vm._v(_vm._s(_vm.calculatedtax))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }